import { Injectable } from '@angular/core';
import { StoreConfig } from '../interfaces/store-config.interface';
import { CacheKey } from '../constants/cachekey.constants';
import { Portals } from 'src/app/common/enums/portal.enum';
import { CacheService } from './cache.service';
import { Country, CountryUrlMetaData } from '../interfaces/country.interface';
import { CommonService } from './common.service';
import { UrlConfig } from '../interfaces/urlconfig.interface';
import { CountryUrlExtensionConstants } from '../constants';
import { environment } from 'src/environments/environment';


@Injectable({ providedIn: 'root' })
export class ReportOnlyCountryService {

    constructor(private _cacheService: CacheService, private _commonService: CommonService) {

    }

    /**
     * whenever a store doesn't have Shop and JOIN 
     * and contains reports are considered as report only country
     */
    public reportOnlyCountry(isoCode: string): boolean {
        const storeConfig: StoreConfig = this._cacheService.get(CacheKey.StoreConfiguration);
        if (storeConfig !== undefined && storeConfig.portals !== undefined
            && storeConfig.portals !== null && storeConfig.portals.length > 0) {
            const hasAllPortalMapping = storeConfig.portals
                .findIndex(m => m.id === Portals.All) == -1 ? false : true;
            const hasReportsPortalAccess = storeConfig.portals
                .findIndex(m => m.id === Portals.Reports) == -1 ? false : true;
            const hasShopAccess = storeConfig.portals
                .findIndex(m => m.id === Portals.Shop) == -1 ? false : true;
            const hasJoinAccess = storeConfig.portals
                .findIndex(m => m.id === Portals.Join) == -1 ? false : true;
            if (!hasAllPortalMapping && hasReportsPortalAccess && !(hasShopAccess || hasJoinAccess)) {
                return true;
            }
        }
        return false;
    }

    public hasAccess(portal: Portals) {
        const storeConfig: StoreConfig = this._cacheService.get(CacheKey.StoreConfiguration);
        if (storeConfig !== undefined && storeConfig.portals !== undefined
            && storeConfig.portals !== null && storeConfig.portals.length > 0) {
            let hasAccess = storeConfig.portals
                .findIndex(m => m.id === Portals.All) == -1 ? false : true;
            if (!hasAccess) {
                hasAccess = storeConfig.portals
                    .findIndex(m => m.id === Portals.Join) == -1 ? false : true;
            }
            return hasAccess;
        }
        return false;
    }

    public reportOnlyCountryNavigationUrl(country: Country, menuItem: string): UrlConfig {
        let urlConfig: UrlConfig;
        let languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
        if (country) {
            let redirectUrl = '';
            redirectUrl = this._commonService.getCountryConfigurationURL(country, menuItem);
            const countryURLMetaData: CountryUrlMetaData = country.urlMetadata && country.urlMetadata.length ?
                country.urlMetadata.find(x => x.portal.toLowerCase() === menuItem.toLowerCase()) : null;
            if (redirectUrl && countryURLMetaData) {
                urlConfig = this.navigateByConfiguredURL(country, redirectUrl, countryURLMetaData);
            } else if (redirectUrl) {
                urlConfig = { url: redirectUrl, target: '_blank' }
            } else {
                urlConfig = {
                    url: '/' + country.isocodeThree.toLowerCase() + '/' + languageCode.toLowerCase()
                        + '/contact-forever-living',
                    target: ''
                }
            }
        }
        return urlConfig;
    }

    /**
* This method used to navigate by configured url
* navigateToConfiguredURL()
*/
    private navigateByConfiguredURL(country: Country, url: string, countryURLMetaData: CountryUrlMetaData): UrlConfig {
        let urlConfig: UrlConfig;
        let urlToNavigate: string;
        let target: string;
        let languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
        switch (countryURLMetaData.urlExtention) {
            case CountryUrlExtensionConstants.LEGACY:
                url = url + '&language=' + (languageCode ? languageCode.split('-')[0] : 'en');
                url = this._commonService.appendFBOID(url, true);
                urlToNavigate = url;
                target = countryURLMetaData.target;
                break;
            case CountryUrlExtensionConstants.CONTACT_FOREVERE_LIVING:
                url = '/' + country.isocodeThree.toLowerCase() + '/' + languageCode.toLowerCase() + '/contact-forever-living'
                urlToNavigate = url;
                target = "";
                break;
            case CountryUrlExtensionConstants.PDF:
                url = environment.cdnURL + '/' + url;
                urlToNavigate = url;
                target = countryURLMetaData.target;
                break;
            default:
                urlToNavigate = url;
                target = countryURLMetaData.target;
                break;
        }
        urlConfig = {
            url: urlToNavigate,
            target: target
        };
        return urlConfig;
    }
}